import { IconButton, Stack, Tooltip } from "@mui/material";
import { FaGem, FaListUl, FaMagnifyingGlass, FaPen, FaTrash } from "react-icons/fa6";
import { Link } from "react-router-dom";
import ListingPage from '../../components/DynamicListingPage';
import { useQuery, useMutation } from "@tanstack/react-query";
import { getStones, deleteStone } from "../../helpers/http_stones_requests";
import { usePermissions } from "../../providers/PermissionsProvider";
import { useAuth } from "../../providers/AuthProvider";
import { confirmAndExecuteFn } from '../../utils/functions';

export default function Stones() {

    const { verifyPermission } = usePermissions();
    const { id: user_id } = useAuth();

    const { data, isFetching, refetch } = useQuery({ queryKey: ['getStones'], queryFn: getStones, staleTime: 1000 * 5 });

    const { data: dataList } = data?.data ?? {};

    const deleteMutation = useMutation({
        mutationFn: (id) => deleteStone(id, user_id),
        onSuccess: () => {
            setTimeout(() => {
                refetch();
            }, 1000);
        }
    });

    const handleDelete = (id) => {
        confirmAndExecuteFn('Tem certeza que deseja deletar esta pedra?', () => {
            deleteMutation.mutate(id);
        });
    };

    const columns = [
        {
            field: 'name',
            headerName: 'Nome',
        },
        {
            field: 'description',
            headerName: 'Descrição',
        },
        {
            field: 'actions',
            headerName: 'Ações',
            type: 'number',
        },
    ];

    const componentName = 'products';

    const renderActions = (row) => (
        <Stack spacing={1} direction={'row'} justifyContent={'center'}>
            {verifyPermission(componentName, 1) && (
                <>
                    <Tooltip title="Lista de variações" arrow placement="top">
                        <IconButton color="primary" LinkComponent={Link} to={`/pedra-variacoes/${row.id}`}>
                            <FaListUl size={20} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Ver detalhes" arrow placement="top">
                        <IconButton color="primary" LinkComponent={Link} to={`/pedra-detalhes/${row.id}`}>
                            <FaMagnifyingGlass size={20} />
                        </IconButton>
                    </Tooltip>
                </>
            )}
            {verifyPermission(componentName, 2) && (
                <Tooltip title="Editar" arrow placement="top">
                    <IconButton color="primary" LinkComponent={Link} to={`/pedra-editar/${row.id}`}>
                        <FaPen size={20} />
                    </IconButton>
                </Tooltip>
            )}
            {verifyPermission(componentName, 4) && (
                <Tooltip title="Deletar" arrow placement="top">
                    <IconButton color="error" onClick={() => handleDelete(row.id)}>
                        <FaTrash size={20} />
                    </IconButton>
                </Tooltip>
            )}
        </Stack>
    );

    return <ListingPage canAddData={verifyPermission(componentName, 3)} isLoading={isFetching} icon={FaGem} pageTitle={"Pedras"} addButtonTitle={"pedra"} addPath={"/pedra-cadastrar"} columns={columns} data={dataList} actions={renderActions} />
};